import { render, staticRenderFns } from "./BookCategoryAddModal.vue?vue&type=template&id=3e35dc60&"
import script from "./BookCategoryAddModal.vue?vue&type=script&lang=js&"
export * from "./BookCategoryAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports